import PortalCurrencyIcon from '@/components/common/PortalCurrencyIcon';
import { store } from '@/state/store';
import { getCurrency } from '@/utils/hooks/useCurrency';
import cn from 'classnames';

export interface CurrencyOption {
    label: string;
    ccy: string;
    value: string;
    celer: string;
}

export const getOtherCurrency = (currency: string, securityId: string) => {
    if (securityId.indexOf('/') == -1) return '';
    const [baseCurrency, quoteCurrency] = securityId.split('/');
    return currency.toLowerCase() == baseCurrency.toLowerCase()
        ? quoteCurrency
        : currency.toLowerCase() == quoteCurrency.toLowerCase()
        ? baseCurrency
        : '';
};

export const getCurrencyOptions = () => {
    return store.getState().oho.currencyConfigs.map((ccy) => {
        return {
            label: ccy.longName,
            ccy: ccy.show.toLowerCase(),
            value: ccy.show,
            celer: ccy.celer
        };
    });
};

export const getCurrencyConfigDict = () => {
    return store.getState().oho.currencyConfigs.reduce((acc, curr) => {
        if (curr.celer !== curr.show) acc[curr.show] = curr;
        acc[curr.celer] = curr;

        return acc;
    }, {});
};

export const ccyOption = (name: string) => getCurrencyOptions().find((ccy) => ccy.ccy === name);
export const celerCcyOption = (celer: string) =>
    getCurrencyOptions().find((ccy) => ccy.celer === celer || ccy.value === celer);
export const celerCcyName = (name: string) => getCurrencyOptions().find((ccy) => ccy.value === name)?.celer || name;
export const availableCcyOption = (options: CurrencyOption[], name: string) => options.find((ccy) => ccy.ccy === name);

export const generalAmountCell = ({ amount, ccy, formatQty, className = '' }: any) => {
    const { show, type } = getCurrency(ccy || '');
    // const symbol = getSymbolFromCurrency(show || '') || '';

    if (isNaN(amount) || amount === 0) {
        return <div className={cn('', className)}>-</div>;
    }
    // else if (type === 'Fiat') {
    //     return (
    //         <div
    //             className={cn(
    //                 'flex items-center gap-1',
    //                 {
    //                     'text-brand-green-light': amount > 0,
    //                     'text-brand-red-light': amount < 0
    //                 },
    //                 className
    //             )}>
    //             <div>{symbol}</div>
    //             {formatQty.format(amount)}
    //         </div>
    //     );
    // }
    else if (type === 'Crypto' || type === 'Fiat') {
        return (
            <div
                className={cn(
                    'flex items-center gap-1',
                    {
                        'text-brand-green-light': amount > 0,
                        'text-brand-red-light': amount < 0
                    },
                    className
                )}>
                <PortalCurrencyIcon show={show} />
                {formatQty.format(amount)}
            </div>
        );
    }

    return (
        <div
            className={cn(
                'flex items-center gap-1',
                {
                    'text-brand-green-light': amount > 0,
                    'text-brand-red-light': amount < 0
                },
                className
            )}>
            <PortalCurrencyIcon show={show} />
            {amount}
        </div>
    );
};
